// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/PPNeueMachina-InktrapLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/PPNeueMachina-InktrapLightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/PPNeueMachina-InktrapRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/fonts/PPNeueMachina-InktrapUltrabold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PPNeueMachina Inktrap Light */
@font-face {
  font-family: "PPNeueMachina";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "PPNeueMachina";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "PPNeueMachina";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "PPNeueMachina";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
  font-weight: 800;
  font-style: normal;
}


body {
  margin: 0;
  font-family: "PPNeueMachina", sans-serif;
  background-color: #000; /* Optional background color */
  color: #fff; /* Optional text color */
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,4BAA4B;EAC5B,+DAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAmF;EACnF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAiF;EACjF,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,SAAS;EACT,wCAAwC;EACxC,sBAAsB,EAAE,8BAA8B;EACtD,WAAW,EAAE,wBAAwB;AACvC","sourcesContent":["/* PPNeueMachina Inktrap Light */\n@font-face {\n  font-family: \"PPNeueMachina\";\n  src: url(\"../public/fonts/PPNeueMachina-InktrapLight.otf\") format(\"opentype\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"PPNeueMachina\";\n  src: url(\"../public/fonts/PPNeueMachina-InktrapLightItalic.otf\") format(\"opentype\");\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"PPNeueMachina\";\n  src: url(\"../public/fonts/PPNeueMachina-InktrapRegular.otf\") format(\"opentype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"PPNeueMachina\";\n  src: url(\"../public/fonts/PPNeueMachina-InktrapUltrabold.otf\") format(\"opentype\");\n  font-weight: 800;\n  font-style: normal;\n}\n\n\nbody {\n  margin: 0;\n  font-family: \"PPNeueMachina\", sans-serif;\n  background-color: #000; /* Optional background color */\n  color: #fff; /* Optional text color */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
